const MapIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 6.74965V11.2496C16.5 13.1246 16.125 14.4371 15.285 15.2846L10.5 10.4996L16.2975 4.70215C16.4325 5.29465 16.5 5.96965 16.5 6.74965Z"
        stroke="#1D67B6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2975 4.7025L4.70249 16.2975C2.44499 15.78 1.5 14.22 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H11.25C14.22 1.5 15.78 2.445 16.2975 4.7025Z"
        stroke="#1D67B6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2847 15.285C14.4372 16.125 13.1247 16.5 11.2497 16.5H6.74966C5.96966 16.5 5.29465 16.4325 4.70215 16.2975L10.4997 10.5L15.2847 15.285Z"
        stroke="#1D67B6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.67995 5.98504C5.18995 3.78754 8.48996 3.78754 8.99996 5.98504C9.29246 7.27504 8.48245 8.37004 7.76995 9.04504C7.25245 9.54004 6.43496 9.54004 5.90996 9.04504C5.19746 8.37004 4.37995 7.27504 4.67995 5.98504Z"
        stroke="#1D67B6"
        strokeWidth="1.5"
      />
      <path
        d="M6.82108 6.52539H6.82781"
        stroke="#1D67B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MapIcon;
